import { Injectable } from '@angular/core';
import { ApiService, sanitizeGet } from './api.service';
import { Config } from '../models/config.model';

@Injectable()
export class ConfigService {
  public basePath: string = '/config';

  constructor(
    private _apiService: ApiService,
  ) {
  }

  public updateBulk(data: any): Promise<Config> {
    return this._apiService
      .put(`${this.basePath}/bulk`, data).toPromise();
  }

  public getSelectives(): Promise<Array<Config>> {
    return this._apiService
      .get(`${this.basePath}/selectives`).toPromise();
  }

  public runDatabaseScript(): Promise<Config> {
    return this._apiService
      .post(`${this.basePath}/database-script`).toPromise();
  }
}